import React, {useEffect, useState} from "react";
import {Link, useHistory, useLocation} from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";

import LoginForm from "../../Components/Forms/Login";
import {useMediaQuery} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {RootState, useAppDispatch} from "../../redux/store";
import {ReactComponent as LogoSVG} from "../../Images/logo.svg";
import ConfirmEmail from "../../Components/ConfirmEmail/ConfirmEmail";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        zIndex: 1,
    },
});


const Login = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const dispatch = useAppDispatch();
    const branding = useSelector((state: RootState) => state?.branding);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const [isEmailConfirmed, setIsEmailConfirmed] = useState(undefined);

    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot} style={{paddingBottom: isWhiteLabel ? "0" : "40px"}}>
                {isEmailConfirmed === false
                    ?
                    <ConfirmEmail />
                    :
                    <>
                        <Box margin={isMobile ? "35px 0" : "0"} display="flex" justifyContent="center">
                            {
                                isWhiteLabel &&
                            <img
                                alt="brand logo"
                                src={branding.logo}
                                width="60%"
                                height="60%"
                            />
                            }
                        </Box>
                        <Box margin={isMobile ? "0" : "35px 0"}>
                            <Typography
                                variant="h2"
                                align="center"
                            >
                            Welcome back!
                            </Typography>
                        </Box>
                        <LoginForm setIsEmailConfirmed={setIsEmailConfirmed}/>
                        {
                            isWhiteLabel &&
                        <Box display="flex" justifyContent="center" alignItems="center" marginTop="15px">
                            <Typography color="primary" style={{fontSize: 14, marginRight: "10px"}}>Powered
                                by</Typography>
                            < LogoSVG style={{width: 47}}/>
                        </Box>
                        }
                    </>}
                <Typography align="center" style={{fontSize: "20px", marginTop: "20px"}}>
                    Don’t have an account? <Link to="/signUp">Sign Up!</Link>
                </Typography>
            </Card>

        </Container>
    );
};

export default Login;
